import styled from 'styled-components';

export const Overlay = styled.div`
  background-color: ${({ backgroundColor }) => backgroundColor || 'rgba(0, 0, 0, 0.3)'};
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${({ zIndex }) => zIndex || 1};
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ pointerEvents }) => pointerEvents && `pointer-events: ${pointerEvents}`};
`;
